import { render, staticRenderFns } from "./PatientHistoryDetail.vue?vue&type=template&id=5ccd8d54"
import script from "./PatientHistoryDetail.vue?vue&type=script&lang=js"
export * from "./PatientHistoryDetail.vue?vue&type=script&lang=js"
import style0 from "./PatientHistoryDetail.vue?vue&type=style&index=0&id=5ccd8d54&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports